import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Icon from '@material-ui/core/Icon';
import classnames from 'classnames';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import { StandardRadioGroup } from '../StandardRadioGroup';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendIconRenderer } from '../../LegendRenderer/LegendIconRenderer';
import { LEGEND_ICON_TYPES } from '../../../types/legendTypes';
import styles from '../FilterSidebar.module.css';

const H3_ZOOMS = [ 6, 7, 8, 9, 10, 11, 12, 'auto' ];
// Цвет заливки гексагона в легенде (полупрозрачный синий — нейтральный технический)
const HEX_COLOR = 'rgba(100, 149, 237, 0.5)';
const H3GridLegendComponent = ({ onChangeMapFilters, h3GridH3Zoom }) => {
    const [ isH3ZoomExpanded, setIsH3ZoomExpanded ] = useState(false);
    const handleH3ZoomChange = ({ target: { value } }) => {
        onChangeMapFilters('h3GridH3Zoom', value);
    };
    const toggleH3Zoom = () => {
        setIsH3ZoomExpanded(!isH3ZoomExpanded);
    };

    return (
        <div>
            {/* Заголовок легенды */}
            <div className={styles.legHead}>{t`Сетка гексагонов H3`}</div>

            {/* Единственный пункт: гексагон + подпись */}
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: '16px 1fr',
                    columnGap: '12px',
                    rowGap: '8px',
                    alignItems: 'center',
                    paddingLeft: '10px',
                    marginBottom: '8px',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '16px',
                        height: '16px',
                        flexShrink: 0,
                    }}
                >
                    <LegendIconRenderer
                        type={LEGEND_ICON_TYPES.HEXAGON}
                        color={HEX_COLOR}
                        size="100%"
                        opacity={0.85}
                    />
                </div>
                <p style={{ fontSize: '12px', margin: 0, lineHeight: '1.4' }}>
                    {t`ячейка сетки`}
                </p>
            </div>

            {/* H3 Zoom контрол */}
            <div
                className={classnames(styles.legHead, {
                    [styles.expandableLegHead]: true,
                    [styles.expandableLegHeadOpen]: isH3ZoomExpanded,
                })}
                onClick={toggleH3Zoom}
                style={{ cursor: 'pointer', userSelect: 'none', display: 'inline-flex', alignItems: 'center' }}
            >
                {t`H3 Zoom`}:
                <Icon style={{ marginLeft: 'auto', transition: 'transform 0.25s ease' }}>expand_more</Icon>
            </div>
            {isH3ZoomExpanded && (
                <StandardRadioGroup
                    value={String(h3GridH3Zoom)}
                    onChange={handleH3ZoomChange}
                >
                    {H3_ZOOMS.map(zoom => (
                        <FormControlLabel
                            key={zoom}
                            className={styles.isochroneFilterLabel}
                            control={
                                <Radio
                                    checked={String(h3GridH3Zoom) === String(zoom)}
                                    onChange={handleH3ZoomChange}
                                    value={String(zoom)}
                                    className={classnames(
                                        styles.isochroneFilterInput, {
                                            [styles.checkedIsochroneFilterInput]: String(h3GridH3Zoom) === String(zoom),
                                        }
                                    )}
                                    size="small"
                                />
                            }
                            label={zoom}
                        />
                    ))}
                </StandardRadioGroup>
            )}
        </div>
    );
};
const mapStateToProps = ({ mapFilters: { h3GridH3Zoom } }) => ({ h3GridH3Zoom });
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(H3GridLegendComponent);

export const H3GridLegend = withDisplayedLayersCheck(
    ConnectedComponent,
    'Адреса гексагонов H3'
);
